import { onMounted } from "vue";
let installed = false;
function uiNormalizeVh() {
  onMounted(async () => {
    if (installed) {
      return;
    }
    installed = true;
    function updateVhProperty() {
      let vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty("--vh", `${vh}px`);
    }
    updateVhProperty();
    window.addEventListener("resize", () => {
      updateVhProperty();
    });
  });
}
export { uiNormalizeVh as default };
